/* eslint-disable no-unused-vars */
/* eslint-disable no-mixed-operators */
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import './css/Player1StatsBox.css';
import CircularProgressWithLabel from './CircularProgressWithLabel';

const Player1StatsBox1 = (props) => {
    const { isGoalie, stats } = props;

    const allSeasons = () => {
        return stats.length;
    };

    const gamesPlayed = () => {
        let games = 0;
        stats.forEach((stat) => {
            games += stat.gamesPlayed;
        });
        return games;
    };

    const allWins = () => {
        let wins = 0;
        stats.forEach((stat) => {
            wins += stat.wins;
        });
        return wins;
    };

    const allGoals = () => {
        let goals = 0;
        stats.forEach((stat) => {
            goals += stat.goals;
        });
        return goals;
    };

    const allAssits = () => {
        let assists = 0;
        stats.forEach((stat) => {
            assists += stat.assists;
        });
        return assists;
    };

    const allPoints = () => {
        return allGoals() + allAssits();
    };

    const allShots = () => {
        let shots = 0;
        stats.forEach((stat) => {
            shots += stat.shots;
        });
        return shots;
    };

    const allGoalsConceded = () => {
        let goals = 0;
        stats.forEach((stat) => {
            goals += stat.goalieGoalsConceded;
        });
        return goals;
    };

    const allPowerPlayGoals = () => {
        let goals = 0;
        stats.forEach((stat) => {
            goals += stat.powerPlayGoals;
        });
        return goals;
    };

    const allShortHandedGoals = () => {
        let goals = 0;
        stats.forEach((stat) => {
            goals += stat.shortHandedGoals;
        });
        return goals;
    };

    const allGameWinningGoals = () => {
        let goals = 0;
        stats.forEach((stat) => {
            goals += stat.gameWinningGoals;
        });
        return goals;
    };

    const allPowerPlayGoalsAgainst = () => {
        let goals = 0;
        stats.forEach((stat) => {
            goals += stat.goaliePowerPlayGoals;
        });
        return goals;
    };

    const allShortHandedGoalsAgainst = () => {
        let goals = 0;
        stats.forEach((stat) => {
            goals += stat.goalieShortHandedGoals;
        });
        return goals;
    };

    const allEmptyNetGoalsAgainst = () => {
        let goals = 0;
        stats.forEach((stat) => {
            goals += stat.goalieEmptyNetGoals;
        });
        return goals;
    };

    const allSaves = () => {
        let saves = 0;
        stats.forEach((stat) => {
            saves += stat.goalieShotsSaved;
        });
        return saves;
    };

    const allShotsOnGoals = () => {
        let goals = 0;
        stats.forEach((stat) => {
            goals += stat.goalieShotsOnGoal;
        });
        return goals;
    };

    const allPenaltyMinutes = () => {
        let penaltyMinutes = 0;
        stats.forEach((stat) => {
            penaltyMinutes += stat.penaltyMinutes;
        });
        return penaltyMinutes;
    };

    const allShutOut = () => {
        let shutOuts = 0;
        stats.forEach((stat) => {
            shutOuts += stat.shutOuts;
        });
        return shutOuts;
    };

    return (
        <>
            <p className="font-size-2xl text-left-align text-uppercase">Average Stats</p>
            <div className="player1-stats1-tab-average-stats box-shadow-black curve-border-20px p-t-70px p-b-70px p-l-100px p-r-100px m-b-30px bg-white x-center">
                {!isGoalie ? (
                    <>
                        <div className="left">
                            <CircularProgressWithLabel title="Win %" value={(100 * allWins() / gamesPlayed()).toFixed(0)} maxValue={100} isPercentage justifyContent="flex-start" />
                            <CircularProgressWithLabel title="Points Per Season" value={(allPoints() / allSeasons()).toFixed(0)} maxValue={20} justifyContent="flex-start" />
                            <CircularProgressWithLabel title="Powerplay Goals %" value={(100 * allPowerPlayGoals() / allGoals()).toFixed(0)} maxValue={100} isPercentage justifyContent="flex-start" />
                        </div>
                        <div className="right m-l-200px">
                            <CircularProgressWithLabel title="Penalty Min Per Game" value={(allPenaltyMinutes() / gamesPlayed()).toFixed(0)} maxValue={60} isPercentage={false} justifyContent="flex-end" />
                            <CircularProgressWithLabel title="Shots To Goal" value={(100 * allShots() / allGoals()).toFixed(0)} maxValue={100} isPercentage justifyContent="flex-end" />
                            <CircularProgressWithLabel title="Shorthand Goals %" value={(100 * allShortHandedGoals() / allGoals()).toFixed(0)} maxValue={100} isPercentage justifyContent="flex-end" />
                        </div>
                    </>
                ) : (
                    <>
                        <div className="left">
                            <CircularProgressWithLabel title="Win %" value={(100 * allWins() / gamesPlayed()).toFixed(0)} maxValue={100} isPercentage justifyContent="flex-start" />
                            <CircularProgressWithLabel title="Empty Net Goals %" value={(100 * allEmptyNetGoalsAgainst() / allGoalsConceded()).toFixed(0)} maxValue={100} isPercentage justifyContent="flex-start" />
                            <CircularProgressWithLabel title="Powerplay Goals %" value={(100 * allPowerPlayGoalsAgainst() / allGoalsConceded()).toFixed(0)} maxValue={100} isPercentage justifyContent="flex-start" />
                        </div>
                        <div className="right m-l-200px">
                            <CircularProgressWithLabel title="Shut Out %" value={(100 * allShutOut() / gamesPlayed()).toFixed(0)} maxValue={100} isPercentage justifyContent="flex-end" />
                            <CircularProgressWithLabel title="Total Saves Per Shots" value={(100 * allSaves() / allShotsOnGoals()).toFixed(0)} maxValue={100} isPercentage justifyContent="flex-end" />
                            <CircularProgressWithLabel title="Short Handed Goals %" value={(100 * allShortHandedGoalsAgainst() / allGoalsConceded()).toFixed(0)} maxValue={100} isPercentage justifyContent="flex-end" />
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

Player1StatsBox1.propTypes = {
    isGoalie: PropTypes.bool.isRequired,
    stats: PropTypes.array.isRequired,
};

export default memo(Player1StatsBox1);
